import { createContext, useContext } from "react"

type Translatable = { translations?: PlaybookTranslations<any> }

export const LanguageContext = createContext<string | undefined>(undefined)

export function useLanguage() {
  return useContext(LanguageContext)
}

export function languageName(code: string) {
  try { return new Intl.DisplayNames(["en"], { type: "language" }).of(code) ?? code } catch { return code }
}

export function localized<T extends Translatable, K extends keyof T & string>(target: T, field: K, language?: string): T[K] | undefined {
  return language ? target.translations?.[language]?.[field] : target[field]
}

export function localize<T extends Translatable>(target: T, field: keyof T & string, value: any, language?: string): T {
  if (!language) return { ...target, [field]: value }
  const entry = { ...target.translations?.[language], [field]: value }
  if (value === undefined || value === "" || (Array.isArray(value) && !value.length)) delete entry[field]
  const translations = { ...target.translations, [language]: entry }
  if (!Object.keys(entry).length) delete translations[language]
  return { ...target, translations: Object.keys(translations).length ? translations : undefined }
}
